<template>
  <div class="uk-text-center">
    <div class="uk-section uk-padding-large">
        <h4>Mobile is coming soon!</h4>
        <p style="padding: 0 40px 0 40px">In the meantime, make your browser window larger to use this app.</p>
    </div>
    <div class="uk-animation-slide-top-small">
        <img src="/img/illustrations/doodles/mobile_phone.png"/>
    </div>
    <div class="hero">
      <div class="grid">      
        <div class="grid-block block1"></div>          
        <div v-for="n in 80" :key="n" :class="['grid-block', 'block'+n]"></div>
      </div>
    </div>  
    <div class="uk-margin-large-top" style="display: block; margin: auto; width: 60vw;">
        <svg width="100%" height="100%" viewBox="0 0 441 49" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;">
            <g transform="matrix(1,0,0,1,-217.867,-443.326)">
                <g transform="matrix(4.97792,0,0,5.01892,-1101.74,-1983.69)">
                    <text x="264.983px" y="492.946px" style="font-family:'Comfortaa';font-weight:700;font-size:12px;fill:white;">W<tspan x="274.919px " y="492.946px ">a</tspan>termarks</text>
                    <text x="339.647px" y="492.946px" style="font-family:'Comfortaa';font-weight:700;font-size:12px;fill:rgb(255,191,0);">.io</text>
                </g>
            </g>
        </svg>
    </div>        
    <div class="uk-text-center uk-margin-large-top">
        <a class="uk-icon-button go-back-btn" href="https://watermarks.io">
             <span class="go-back-btn-text"><i class="material-icons uk-inline">arrow_back</i> Go back</span>
        </a>
    </div> 
  </div>
</template>

<script>
  export default {
    name: 'MobileComing',
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
  .go-back-btn {
    width: auto !important;
    color: rgba(255, 255, 255, 0.8) !important;
    background-color: rgba(255, 255, 255, 0) !important;
    border: 2px solid rgba(255, 255, 255, 0.8) !important;
    text-decoration: none !important;
    transition: 0.4s;
  }

  .go-back-btn:hover {
    background-color: rgba(255, 255, 255, 0.2) !important;
    color: rgba(255, 255, 255, 1) !important;
    border: 2px solid rgba(255, 255, 255, 1) !important;
    text-decoration: bold;
    cursor: pointer;
  }

  .go-back-btn-text {
    margin-left: 14px;
    margin-right: 14px;
    font-size: 16px;
  }

/* Background animation */
.hero {
  background: #28a5f5;
  height: 100vh;
  width: 100vw;
    position: absolute;
    top: 40vh;
    left: 0;
    z-index: -100;  
    transform: skewY(10.5deg);
    transform-origin: 100%;
  overflow: hidden;
}
.grid {
  transform: rotate(45deg);
}
.grid .grid-block {
  background: rgba(255, 255, 255, 0.356);
  margin: 3px;
  display: inline-block;
  position: absolute;
  top: -300vh;
}
@keyframes changewidth {
  from {
    top: -350vh;
  }
  to {
    top: 350vh;
  }
}
.grid .block1 {
  left: 2vw;
  min-height: 5px;
  animation-duration: 400ms;
  animation-delay: 1ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 1;
  min-width: 1px;
  border-radius: 1px;
}
.grid .block2 {
  left: 4vw;
  min-height: 50px;
  animation-duration: 4000ms;
  animation-delay: 10ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 10;
  min-width: 10px;
  border-radius: 10px;
}
.grid .block3 {
  left: 6vw;
  min-height: 130px;
  animation-duration: 10400ms;
  animation-delay: 26ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 26;
  min-width: 26px;
  border-radius: 26px;
}
.grid .block4 {
  left: 8vw;
  min-height: 55px;
  animation-duration: 4400ms;
  animation-delay: 11ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 11;
  min-width: 11px;
  border-radius: 11px;
}
.grid .block5 {
  left: 10vw;
  min-height: 160px;
  animation-duration: 12800ms;
  animation-delay: 32ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 32;
  min-width: 32px;
  border-radius: 32px;
}
.grid .block6 {
  left: 12vw;
  min-height: 125px;
  animation-duration: 10000ms;
  animation-delay: 25ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 25;
  min-width: 25px;
  border-radius: 25px;
}
.grid .block7 {
  left: 14vw;
  min-height: 245px;
  animation-duration: 19600ms;
  animation-delay: 49ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 49;
  min-width: 49px;
  border-radius: 49px;
}
.grid .block8 {
  left: 16vw;
  min-height: 245px;
  animation-duration: 19600ms;
  animation-delay: 49ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 49;
  min-width: 49px;
  border-radius: 49px;
}
.grid .block9 {
  left: 18vw;
  min-height: 10px;
  animation-duration: 800ms;
  animation-delay: 2ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 2;
  min-width: 2px;
  border-radius: 2px;
}
.grid .block10 {
  left: 20vw;
  min-height: 200px;
  animation-duration: 16000ms;
  animation-delay: 40ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 40;
  min-width: 40px;
  border-radius: 40px;
}
.grid .block11 {
  left: 22vw;
  min-height: 125px;
  animation-duration: 10000ms;
  animation-delay: 25ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 25;
  min-width: 25px;
  border-radius: 25px;
}
.grid .block12 {
  left: 24vw;
  min-height: 160px;
  animation-duration: 12800ms;
  animation-delay: 32ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 32;
  min-width: 32px;
  border-radius: 32px;
}
.grid .block13 {
  left: 26vw;
  min-height: 100px;
  animation-duration: 8000ms;
  animation-delay: 20ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 20;
  min-width: 20px;
  border-radius: 20px;
}
.grid .block14 {
  left: 28vw;
  min-height: 195px;
  animation-duration: 15600ms;
  animation-delay: 39ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 39;
  min-width: 39px;
  border-radius: 39px;
}
.grid .block15 {
  left: 30vw;
  min-height: 5px;
  animation-duration: 400ms;
  animation-delay: 1ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 1;
  min-width: 1px;
  border-radius: 1px;
}
.grid .block16 {
  left: 32vw;
  min-height: 230px;
  animation-duration: 18400ms;
  animation-delay: 46ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 46;
  min-width: 46px;
  border-radius: 46px;
}
.grid .block17 {
  left: 34vw;
  min-height: 65px;
  animation-duration: 5200ms;
  animation-delay: 13ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 13;
  min-width: 13px;
  border-radius: 13px;
}
.grid .block18 {
  left: 36vw;
  min-height: 160px;
  animation-duration: 12800ms;
  animation-delay: 32ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 32;
  min-width: 32px;
  border-radius: 32px;
}
.grid .block19 {
  left: 38vw;
  min-height: 165px;
  animation-duration: 13200ms;
  animation-delay: 33ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 33;
  min-width: 33px;
  border-radius: 33px;
}
.grid .block20 {
  left: 40vw;
  min-height: 100px;
  animation-duration: 8000ms;
  animation-delay: 20ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 20;
  min-width: 20px;
  border-radius: 20px;
}
.grid .block21 {
  left: 42vw;
  min-height: 230px;
  animation-duration: 18400ms;
  animation-delay: 46ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 46;
  min-width: 46px;
  border-radius: 46px;
}
.grid .block22 {
  left: 44vw;
  min-height: 185px;
  animation-duration: 14800ms;
  animation-delay: 37ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 37;
  min-width: 37px;
  border-radius: 37px;
}
.grid .block23 {
  left: 46vw;
  min-height: 95px;
  animation-duration: 7600ms;
  animation-delay: 19ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 19;
  min-width: 19px;
  border-radius: 19px;
}
.grid .block24 {
  left: 48vw;
  min-height: 95px;
  animation-duration: 7600ms;
  animation-delay: 19ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 19;
  min-width: 19px;
  border-radius: 19px;
}
.grid .block25 {
  left: 50vw;
  min-height: 125px;
  animation-duration: 10000ms;
  animation-delay: 25ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 25;
  min-width: 25px;
  border-radius: 25px;
}
.grid .block26 {
  left: 52vw;
  min-height: 165px;
  animation-duration: 13200ms;
  animation-delay: 33ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 33;
  min-width: 33px;
  border-radius: 33px;
}
.grid .block27 {
  left: 54vw;
  min-height: 190px;
  animation-duration: 15200ms;
  animation-delay: 38ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 38;
  min-width: 38px;
  border-radius: 38px;
}
.grid .block28 {
  left: 56vw;
  min-height: 160px;
  animation-duration: 12800ms;
  animation-delay: 32ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 32;
  min-width: 32px;
  border-radius: 32px;
}
.grid .block29 {
  left: 58vw;
  min-height: 105px;
  animation-duration: 8400ms;
  animation-delay: 21ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 21;
  min-width: 21px;
  border-radius: 21px;
}
.grid .block30 {
  left: 60vw;
  min-height: 125px;
  animation-duration: 10000ms;
  animation-delay: 25ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 25;
  min-width: 25px;
  border-radius: 25px;
}
.grid .block31 {
  left: 62vw;
  min-height: 240px;
  animation-duration: 19200ms;
  animation-delay: 48ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 48;
  min-width: 48px;
  border-radius: 48px;
}
.grid .block32 {
  left: 64vw;
  min-height: 170px;
  animation-duration: 13600ms;
  animation-delay: 34ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 34;
  min-width: 34px;
  border-radius: 34px;
}
.grid .block33 {
  left: 66vw;
  min-height: 245px;
  animation-duration: 19600ms;
  animation-delay: 49ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 49;
  min-width: 49px;
  border-radius: 49px;
}
.grid .block34 {
  left: 68vw;
  min-height: 35px;
  animation-duration: 2800ms;
  animation-delay: 7ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 7;
  min-width: 7px;
  border-radius: 7px;
}
.grid .block35 {
  left: 70vw;
  min-height: 180px;
  animation-duration: 14400ms;
  animation-delay: 36ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 36;
  min-width: 36px;
  border-radius: 36px;
}
.grid .block36 {
  left: 72vw;
  min-height: 230px;
  animation-duration: 18400ms;
  animation-delay: 46ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 46;
  min-width: 46px;
  border-radius: 46px;
}
.grid .block37 {
  left: 74vw;
  min-height: 190px;
  animation-duration: 15200ms;
  animation-delay: 38ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 38;
  min-width: 38px;
  border-radius: 38px;
}
.grid .block38 {
  left: 76vw;
  min-height: 125px;
  animation-duration: 10000ms;
  animation-delay: 25ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 25;
  min-width: 25px;
  border-radius: 25px;
}
.grid .block39 {
  left: 78vw;
  min-height: 250px;
  animation-duration: 20000ms;
  animation-delay: 50ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 50;
  min-width: 50px;
  border-radius: 50px;
}
.grid .block40 {
  left: 80vw;
  min-height: 205px;
  animation-duration: 16400ms;
  animation-delay: 41ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 41;
  min-width: 41px;
  border-radius: 41px;
}
.grid .block41 {
  left: 82vw;
  min-height: 180px;
  animation-duration: 14400ms;
  animation-delay: 36ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 36;
  min-width: 36px;
  border-radius: 36px;
}
.grid .block42 {
  left: 84vw;
  min-height: 185px;
  animation-duration: 14800ms;
  animation-delay: 37ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 37;
  min-width: 37px;
  border-radius: 37px;
}
.grid .block43 {
  left: 86vw;
  min-height: 95px;
  animation-duration: 7600ms;
  animation-delay: 19ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 19;
  min-width: 19px;
  border-radius: 19px;
}
.grid .block44 {
  left: 88vw;
  min-height: 45px;
  animation-duration: 3600ms;
  animation-delay: 9ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 9;
  min-width: 9px;
  border-radius: 9px;
}
.grid .block45 {
  left: 90vw;
  min-height: 20px;
  animation-duration: 1600ms;
  animation-delay: 4ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 4;
  min-width: 4px;
  border-radius: 4px;
}
.grid .block46 {
  left: 92vw;
  min-height: 80px;
  animation-duration: 6400ms;
  animation-delay: 16ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 16;
  min-width: 16px;
  border-radius: 16px;
}
.grid .block47 {
  left: 94vw;
  min-height: 40px;
  animation-duration: 3200ms;
  animation-delay: 8ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 8;
  min-width: 8px;
  border-radius: 8px;
}
.grid .block48 {
  left: 96vw;
  min-height: 175px;
  animation-duration: 14000ms;
  animation-delay: 35ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 35;
  min-width: 35px;
  border-radius: 35px;
}
.grid .block49 {
  left: 98vw;
  min-height: 120px;
  animation-duration: 9600ms;
  animation-delay: 24ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 24;
  min-width: 24px;
  border-radius: 24px;
}
.grid .block50 {
  left: 100vw;
  min-height: 200px;
  animation-duration: 16000ms;
  animation-delay: 40ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 40;
  min-width: 40px;
  border-radius: 40px;
}
.grid .block51 {
  left: 102vw;
  min-height: 135px;
  animation-duration: 10800ms;
  animation-delay: 27ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 27;
  min-width: 27px;
  border-radius: 27px;
}
.grid .block52 {
  left: 104vw;
  min-height: 150px;
  animation-duration: 12000ms;
  animation-delay: 30ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 30;
  min-width: 30px;
  border-radius: 30px;
}
.grid .block53 {
  left: 106vw;
  min-height: 150px;
  animation-duration: 12000ms;
  animation-delay: 30ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 30;
  min-width: 30px;
  border-radius: 30px;
}
.grid .block54 {
  left: 108vw;
  min-height: 235px;
  animation-duration: 18800ms;
  animation-delay: 47ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 47;
  min-width: 47px;
  border-radius: 47px;
}
.grid .block55 {
  left: 110vw;
  min-height: 235px;
  animation-duration: 18800ms;
  animation-delay: 47ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 47;
  min-width: 47px;
  border-radius: 47px;
}
.grid .block56 {
  left: 112vw;
  min-height: 100px;
  animation-duration: 8000ms;
  animation-delay: 20ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 20;
  min-width: 20px;
  border-radius: 20px;
}
.grid .block57 {
  left: 114vw;
  min-height: 140px;
  animation-duration: 11200ms;
  animation-delay: 28ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 28;
  min-width: 28px;
  border-radius: 28px;
}
.grid .block58 {
  left: 116vw;
  min-height: 70px;
  animation-duration: 5600ms;
  animation-delay: 14ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 14;
  min-width: 14px;
  border-radius: 14px;
}
.grid .block59 {
  left: 118vw;
  min-height: 65px;
  animation-duration: 5200ms;
  animation-delay: 13ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 13;
  min-width: 13px;
  border-radius: 13px;
}
.grid .block60 {
  left: 120vw;
  min-height: 35px;
  animation-duration: 2800ms;
  animation-delay: 7ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 7;
  min-width: 7px;
  border-radius: 7px;
}
.grid .block61 {
  left: 122vw;
  min-height: 190px;
  animation-duration: 15200ms;
  animation-delay: 38ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 38;
  min-width: 38px;
  border-radius: 38px;
}
.grid .block62 {
  left: 124vw;
  min-height: 225px;
  animation-duration: 18000ms;
  animation-delay: 45ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 45;
  min-width: 45px;
  border-radius: 45px;
}
.grid .block63 {
  left: 126vw;
  min-height: 170px;
  animation-duration: 13600ms;
  animation-delay: 34ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 34;
  min-width: 34px;
  border-radius: 34px;
}
.grid .block64 {
  left: 128vw;
  min-height: 70px;
  animation-duration: 5600ms;
  animation-delay: 14ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 14;
  min-width: 14px;
  border-radius: 14px;
}
.grid .block65 {
  left: 130vw;
  min-height: 35px;
  animation-duration: 2800ms;
  animation-delay: 7ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 7;
  min-width: 7px;
  border-radius: 7px;
}
.grid .block66 {
  left: 132vw;
  min-height: 190px;
  animation-duration: 15200ms;
  animation-delay: 38ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 38;
  min-width: 38px;
  border-radius: 38px;
}
.grid .block67 {
  left: 134vw;
  min-height: 180px;
  animation-duration: 14400ms;
  animation-delay: 36ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 36;
  min-width: 36px;
  border-radius: 36px;
}
.grid .block68 {
  left: 136vw;
  min-height: 85px;
  animation-duration: 6800ms;
  animation-delay: 17ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 17;
  min-width: 17px;
  border-radius: 17px;
}
.grid .block69 {
  left: 138vw;
  min-height: 135px;
  animation-duration: 10800ms;
  animation-delay: 27ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 27;
  min-width: 27px;
  border-radius: 27px;
}
.grid .block70 {
  left: 140vw;
  min-height: 180px;
  animation-duration: 14400ms;
  animation-delay: 36ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 36;
  min-width: 36px;
  border-radius: 36px;
}
.grid .block71 {
  left: 142vw;
  min-height: 90px;
  animation-duration: 7200ms;
  animation-delay: 18ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 18;
  min-width: 18px;
  border-radius: 18px;
}
.grid .block72 {
  left: 144vw;
  min-height: 140px;
  animation-duration: 11200ms;
  animation-delay: 28ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 28;
  min-width: 28px;
  border-radius: 28px;
}
.grid .block73 {
  left: 146vw;
  min-height: 40px;
  animation-duration: 3200ms;
  animation-delay: 8ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 8;
  min-width: 8px;
  border-radius: 8px;
}
.grid .block74 {
  left: 148vw;
  min-height: 130px;
  animation-duration: 10400ms;
  animation-delay: 26ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 26;
  min-width: 26px;
  border-radius: 26px;
}
.grid .block75 {
  left: 150vw;
  min-height: 55px;
  animation-duration: 4400ms;
  animation-delay: 11ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 11;
  min-width: 11px;
  border-radius: 11px;
}
.grid .block76 {
  left: 152vw;
  min-height: 180px;
  animation-duration: 14400ms;
  animation-delay: 36ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 36;
  min-width: 36px;
  border-radius: 36px;
}
.grid .block77 {
  left: 154vw;
  min-height: 190px;
  animation-duration: 15200ms;
  animation-delay: 38ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 38;
  min-width: 38px;
  border-radius: 38px;
}
.grid .block78 {
  left: 156vw;
  min-height: 115px;
  animation-duration: 9200ms;
  animation-delay: 23ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 23;
  min-width: 23px;
  border-radius: 23px;
}
.grid .block79 {
  left: 158vw;
  min-height: 150px;
  animation-duration: 12000ms;
  animation-delay: 30ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 30;
  min-width: 30px;
  border-radius: 30px;
}
.grid .block80 {
  left: 160vw;
  min-height: 135px;
  animation-duration: 10800ms;
  animation-delay: 27ms;
  animation-name: changewidth;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  opacity: 27;
  min-width: 27px;
  border-radius: 27px;
}

</style>